import React, { useState } from 'react';
import { EXPERT_AVATAR_FALLBACK } from '../../utils/imageUtils';

export interface MapExpertAvatarPinProps {
  /** URL absolue ou resolue pour l'API Maps */
  src: string;
  alt: string;
}

/**
 * Contenu visuel commun aux marqueurs Google (AdvancedMarker) : pastille avatar 40px.
 */
export const MapExpertAvatarPin: React.FC<MapExpertAvatarPinProps> = ({ src, alt }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <div className="flex h-10 w-10 -translate-y-[10px] items-center justify-center overflow-hidden rounded-full bg-blue-600 shadow-[0_2px_10px_rgba(0,0,0,0.25)]">
      <img
        src={imgSrc}
        alt={alt}
        className="h-10 w-10 object-cover"
        onError={() => setImgSrc(EXPERT_AVATAR_FALLBACK)}
      />
    </div>
  );
};
